import { render } from "./OrganizationSetting.vue?vue&type=template&id=4f4da06f"
import script from "./OrganizationSetting.vue?vue&type=script&lang=js"
export * from "./OrganizationSetting.vue?vue&type=script&lang=js"

import "./OrganizationSetting.vue?vue&type=style&index=0&id=4f4da06f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__